import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { getAuthToken } from "../util/auth";

export default function RequireAuth() {
    const location = useLocation();

    // Prefer both: token + redux user (or whatever your slice stores)
    const token = getAuthToken()?.token;

    const isAuthed = Boolean(token);

    if (!isAuthed) {
        // optionally preserve the intended location in state
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    return <Outlet />;
}
